import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import Dashboard from "./Dashboard";
import StatisticsComponent from "./StatisticsComponent";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function DashboardTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    trackEventMatomo('estatísticas', 'click', 'aba', newValue === 0 ? 'dashboards personalizados' : 'dashboard padrão');
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '90%', justifyContent: 'center', display: 'flex' }}>
        <Tabs value={value}
          sx={{ width: '90%' }}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary">
          <Tab label={t('Dashboard.custom')} value={0} />
          <Tab label={t('Dashboard.default')} value={1} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Dashboard />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <StatisticsComponent />
      </CustomTabPanel>
    </>
  );
}
